import React from "react";
import Meta from "./../components/Meta";
import ContactSection from "./../components/ContactSection";
import PricingSection3 from "./../components/PricingSection3";

function ContactPage(props) {
  return (
    <>
    <br>
    </br>
      <Meta title="Contact" />
      <PricingSection3
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="Get started with PDS"
        subtitle="We offer a range of enterprise solutions and services for IP licensing and monetization, from developer API access to custom app development."
      />
      <ContactSection
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Contact us to learn more"
        subtitle=""
        buttonText="Send message"
        buttonColor="primary"
        buttonInverted={false}
        showNameField={true}
      />
    </>
  );
}

export default ContactPage;
